import {handleActions} from 'redux-actions';
import * as type from './actionTypes'
import {List } from './type';
const initState = {
    productLine: 'All',
    trafficInfo: {
        applicantName: '',
        beginDate: '',
        claimRecords: [
            {
                accidentDate: "2017-12-08 00:06:00",
                accidentType: "2017-12-08 00:06:00",
                id: 0,
                orderId: 0,
                payAmount: 200,
                payDate: "2017-12-08 00:06:00",
                policyOrigin: "阿萨德",
                productLine: ""
            }
        ],
        endDate: '',
        floatingInsCoverageInfos: [
            {
                basicPremium: 0,
                coverageCode: "",
                coverageName: "",
                premium: 0,
                sumLimit: 0
            }
        ],
        floatingRate: {
            accidentRate: "",
            floatingRateEndDate: "",
            floatingRateStartDate: "",
            id: 0,
            noCompensationRate: "",
            orderId: 0,
            productLine: "",
            trafficViolationRate: ""
        },
        floatingVehicleInfo: {
            bodyType: "",
            engineNo: "",
            licensePlateNo: "",
            licensePlateType: "",
            motorTypeCode: "",
            motorUsageTypeCode: "",
            ownerName: "",
            vIN: ""
        },
        insQueryNo: '',
        totalPremium: '',
        trafficViolations: [
            {
                id: 0,
                orderId: 0,
                productLine: "",
                violationDescription: "",
                violationHandleDate: "",
                violationOccurAddress: "",
                violationOccurDate: ""
            }
        ]
    },
    businessInfo: {
        insQueryNo: "V0101AZCN440018001543914109020",
        applicantName: "香橙",
        floatingVehicleInfo: {
          licensePlateNo: "粤SS00254",
          licensePlateType: "小型汽车号牌",
          engineNo: "2392242234",
          vIN: "ASDKF1129H5415519",
          bodyType: "宝马BMW X1 18i越野车",
          motorTypeCode: "六座以下客车",
          motorUsageTypeCode: "非营业个人",
          ownerName: "阿树"
        },
        floatingInsCoverageInfos: [
          {
            coverageCode: "MH",
            coverageName: "车辆损失险",
            sumLimit: 238613.4,
            basicPremium: 100,
            premium: 5348.1
          },
          {
            coverageCode: "TPL",
            coverageName: "机动车第三者责任保险",
            sumLimit: 2000000,
            basicPremium: 100,
            premium: 3543.59
          },
          {
            coverageCode: "DL",
            coverageName: "车上人员责任保险（司机）",
            sumLimit: 20000,
            basicPremium: 100,
            premium: 100.8
          },
          {
            coverageCode: "PL",
            coverageName: "车上人员责任保险（乘客）",
            sumLimit: 50000,
            basicPremium: 100,
            premium: 186.3
          },
          {
            coverageCode: "TR",
            coverageName: "机动车全车盗抢保险",
            sumLimit: 238613.4,
            basicPremium: 100,
            premium: 1547.05
          },
          {
            coverageCode: "GB",
            coverageName: "玻璃单独破碎险",
            sumLimit: null,
            basicPremium: 100,
            premium: 600
          },
          {
            coverageCode: "LBS",
            coverageName: "车身划痕损失险",
            sumLimit: 5000,
            basicPremium: 100,
            premium: 1020
          },
          {
            coverageCode: "SRF",
            coverageName: "指定修理厂险",
            sumLimit: null,
            basicPremium: 100,
            premium: 790.58
          }
        ],
        beginDate: "2018-12-03 00:00:00",
        endDate: "2019-12-03 00:00:00",
        trafficViolations: [
          {
            id: 1,
            orderId: 7160220003457096000,
            productLine: "701",
            violationOccurDate: "2018-12-06 02:42:36",
            violationHandleDate: "2018-12-06 02:42:44",
            violationOccurAddress: "北京",
            violationDescription: "驶入大疆",
            violationNumber: "1.0"
          }
        ],
        claimRecords: [
          {
            id: 1,
            orderId: 7160220003457096000,
            productLine: "701",
            accidentDate: "2017-12-08 00:06:00",
            payDate: "2017-12-07 23:03:00",
            accidentType: 1,
            payAmount: 1000,
            policyOrigin: "事故"
          },
          {
            id: 2,
            orderId: 7160220003457096000,
            productLine: "701",
            accidentDate: "2017-12-08 00:05:00",
            payDate: "2017-12-07 23:02:00",
            accidentType: 2,
            payAmount: 1000,
            policyOrigin: "广州"
          }
        ],
        floatingRate: {
          id: 25,
          orderId: 7160220003457096000,
          productLine: "701",
          trafficViolationRate: "1.00",
          noCompensationRate: "1.00",
          accidentRate: null,
          floatingRateStartDate: "2016-11-02 00:02:00",
          floatingRateEndDate: "2017-11-02 00:01:00"
        },
        totalPremium: 13136.42,
        vehicleTaxation: {
            overDue: 0,
            taxConditionCode: 'T',
            taxDefault: 0,
            taxDue: 0,
            totalAmount: 0
        }
    }
}

const actions = {}

actions[type.FETCH_FLOATINFO] = (state: List, action) => {
    return{
        ...state,
        productLine: action.payload.result.productLine,
        businessInfo: action.payload.result.commFloatingMessage  || {},
        trafficInfo: action.payload.result.ctplFloatingMessage || {}
    }
}

export const insuranceItemsInfo = handleActions(actions, initState)
